import { Logradouro } from './logradouro.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class LogradouroService {

    constructor(private http: Http){
    }

    getLogradouros(): Observable<Logradouro[]> {
        return this.http.get(`${NTECH_API}/logradouro`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/logradouro/logradouro.service.ts